import FullscreenIcon from '@mui/icons-material/Fullscreen';
import { IconButton, Tooltip } from '@mui/material';
import NextLink from 'next/link';

const OpenFullPageButton = ({ href }: { href: string }) => {
  return (
    <Tooltip title="Open full page">
      <IconButton component={NextLink} href={href} size="small" aria-label="Open full page">
        <FullscreenIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};

export default OpenFullPageButton;
